import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FileDetail, FileUploadQuestion } from 'src/app/shared/components/page/page.model';
import { QuestionViewModel } from 'src/app/shared/models/questionview.model';
import * as fs from 'file-saver';
import { BaseHttpService } from 'src/app/shared/services/basehttp.service';
import { Constants } from 'src/app/shared/constants';
import { CardService } from '../../view/card/card.service';
import { Subscription } from 'rxjs';
import { StorageService } from 'src/app/shared/services/token-storage.service';
import * as JSZip from 'jszip';
import { RE2JS } from 're2js';

@Component({
  selector: 'app-inputType-fileUpload',
  templateUrl: './inputType-fileUpload.component.html',
  styleUrls: ['./inputType-fileUpload.component.scss'],
  standalone: false,
})
export class InputTypeFileUploadComponent implements OnInit {
  @Input() question: QuestionViewModel;
  @Input() questionIndex: number;
  @Input() totalQuestion: number;
  @Input() showName?: boolean = true;
  @Input() IsReadOnly?: boolean = false;

  @Output() childQuestion: EventEmitter<QuestionViewModel> =
    new EventEmitter<QuestionViewModel>();

  @Output() inputChange: EventEmitter<Boolean> =
    new EventEmitter<Boolean>();

  @Output() fileUploadInProgress: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  errormgvisible: boolean = false;
  validationerrormessage: string[] = [];
  errorMessages: string[] = [];

  constant: Constants = new Constants();

  queFilesUpload: FileUploadQuestion =
    new FileUploadQuestion();

  @Input() isReset: boolean;

  resetSubscription: Subscription;

  isMultiFileSelection: boolean = false;

  constructor(
    private baseHttpService: BaseHttpService,
    private changeDetectorRef: ChangeDetectorRef,
    private cardService: CardService,
    private storage: StorageService
  ) {}

  ngDoCheck(): void {
    try {
      if (this.question?.errorMessage) {
        this.CheckRequiredValidation();
        this.CheckFileValidations();
      }
    } catch (error) {
      this.logError(
        'File validation check failed',
        error
      );
    }
  }

  onFileChange(
    files: File[],
    questionIndex: number
  ): void {
    try {
      this.errorMessages = [];

      Array.from(files).forEach((file) => {
        const fl =
          new FileDetail();

        fl.file = file;

        fl.size =
          this.bytesToSize(
            file.size,
            2
          );

        this.queFilesUpload.files.push(
          fl
        );

        this.CheckRequiredValidation();
        this.CheckFileValidations();

        this.childQuestion.emit(
          this.question
        );
      });

      this.saveFileResponse();

      const fileInput =
        document.getElementById(
          'uploadfile' +
            questionIndex
        ) as HTMLInputElement | null;

      if (fileInput) {
        fileInput.value = '';
      }

      this.inputChange.emit(true);
    } catch (error) {
      this.logError(
        'File selection failed',
        error
      );
    }
  }

  bytesToSize(
    bytes: number,
    precision: number
  ): string {
    try {
      const kilobyte = 1024;
      const megabyte =
        kilobyte * 1024;
      const gigabyte =
        megabyte * 1024;
      const terabyte =
        gigabyte * 1024;

      if (
        bytes >= 0 &&
        bytes < kilobyte
      ) {
        return bytes + ' B';
      } else if (
        bytes >= kilobyte &&
        bytes < megabyte
      ) {
        return (
          (
            bytes / kilobyte
          ).toFixed(
            precision
          ) + ' KB'
        );
      } else if (
        bytes >= megabyte &&
        bytes < gigabyte
      ) {
        return (
          (
            bytes / megabyte
          ).toFixed(
            precision
          ) + ' MB'
        );
      } else if (
        bytes >= gigabyte &&
        bytes < terabyte
      ) {
        return (
          (
            bytes / gigabyte
          ).toFixed(
            precision
          ) + ' GB'
        );
      } else if (
        bytes >= terabyte
      ) {
        return (
          (
            bytes / terabyte
          ).toFixed(
            precision
          ) + ' TB'
        );
      }

      return bytes + ' B';
    } catch (error) {
      this.logError(
        'File size formatting failed',
        error
      );

      return '';
    }
  }

  saveFileResponse(): void {
    try {
      const previousFiles =
        this.queFilesUpload.files
          .filter(
            (x) =>
              x.filePath
          )
          .map(
            (x, idx) => ({
              Id: x.id,
              filePath:
                x.filePath,
              name: x.name,
              sequence:
                x.sequence ||
                idx + 1,
            })
          );

      const resultFilejson:
        any[] = [
          ...previousFiles,
        ];

      const newFiles =
        this.queFilesUpload.files.filter(
          (x) =>
            x.file &&
            !x.filePath &&
            !x.isFinished
        );

      if (
        newFiles.length === 0
      ) {
        this.question.responseText =
          JSON.stringify(
            resultFilejson
          );

        this.childQuestion.emit(
          this.question
        );

        return;
      }

      const agencyId =
        this.storage.get(
          'LoggedInUserAgencyId'
        );

      newFiles
        .filter(
          (x) =>
            !x.isFinished
        )
        .forEach(
          (x, index) => {
            if (
              x.file &&
              this.question[
                'IsValid'
              ]
            ) {
              const path =
                agencyId
                  ? `${agencyId}/${this.question.questionId}`
                  : `${this.question.questionId}`;

              const formData =
                new FormData();

              formData.append(
                'file',
                x.file,
                x.file.name
              );

              formData.append(
                'questionId',
                this.question.questionId.toString()
              );

              formData.append(
                'FilePath',
                path
              );

              x.isLoading =
                true;

              this.checkAndEmitUploadStatus();

              this.baseHttpService
                .post(
                  this.constant
                    .uploadFileUrl,
                  formData
                )
                .subscribe({
                  next: (
                    response
                  ) => {
                    try {
                      if (
                        response &&
                        response.isScanEnabled &&
                        response.fileId
                      ) {
                        const pollInterval =
                          setInterval(
                            () => {
                              this.baseHttpService
                                .post(
                                  this
                                    .constant
                                    .getFileStatusUrl,
                                  {
                                    fileId:
                                      response.fileId,
                                  }
                                )
                                .subscribe({
                                  next: (
                                    statusResponse
                                  ) => {
                                    try {
                                      if (
                                        statusResponse &&
                                        statusResponse.status !==
                                          null
                                      ) {
                                        clearInterval(
                                          pollInterval
                                        );

                                        x.isLoading =
                                          false;

                                        this.checkAndEmitUploadStatus();

                                        x.isFinished =
                                          true;

                                        if (
                                          statusResponse.isFine
                                        ) {
                                          resultFilejson.push(
                                            {
                                              Id: response.fileId,
                                              filePath:
                                                response.filePath,
                                              name: x.file
                                                ?.name,
                                              sequence:
                                                index +
                                                1,
                                            }
                                          );

                                          this.question.responseText =
                                            JSON.stringify(
                                              resultFilejson
                                            );

                                          x.filePath =
                                            response.filePath;

                                          x.id =
                                            response.fileId;

                                          x.name =
                                            x.file
                                              ?.name;

                                          if (
                                            resultFilejson.length ===
                                            this
                                              .queFilesUpload
                                              .files
                                              .length
                                          ) {
                                            this.childQuestion.emit(
                                              this
                                                .question
                                            );
                                          }
                                        } else {
                                          const fileIndex =
                                            this.queFilesUpload.files.indexOf(
                                              x
                                            );

                                          if (
                                            fileIndex >
                                            -1
                                          ) {
                                            this.queFilesUpload.files.splice(
                                              fileIndex,
                                              1
                                            );

                                            this.pushErrorMsg(
                                              `File '${x.file?.name}' is corrupted and has been removed.`
                                            );

                                            this.errormgvisible =
                                              true;

                                            this.childQuestion.emit(
                                              this
                                                .question
                                            );
                                          }
                                        }
                                      }
                                    } catch (
                                      error
                                    ) {
                                      clearInterval(
                                        pollInterval
                                      );

                                      x.isLoading =
                                        false;

                                      x.isFinished =
                                        true;

                                      this.checkAndEmitUploadStatus();

                                      this.logError(
                                        'File scan processing failed',
                                        error
                                      );
                                    }
                                  },

                                  error: (
                                    error
                                  ) => {
                                    clearInterval(
                                      pollInterval
                                    );

                                    x.isLoading =
                                      false;

                                    x.isFinished =
                                      true;

                                    this.checkAndEmitUploadStatus();

                                    this.logError(
                                      'File status check failed',
                                      error
                                    );
                                  },
                                });
                            },
                            10000
                          );
                      }

                      if (
                        response &&
                        !response.isScanEnabled
                      ) {
                        x.isLoading =
                          false;

                        x.isFinished =
                          true;

                        this.checkAndEmitUploadStatus();

                        resultFilejson.push(
                          {
                            Id: response.fileId,
                            filePath:
                              response.filePath,
                            name: x.file
                              ?.name,
                            sequence:
                              index +
                              1,
                          }
                        );

                        this.question.responseText =
                          JSON.stringify(
                            resultFilejson
                          );

                        x.filePath =
                          response.filePath;

                        x.id =
                          response.fileId;

                        x.name =
                          x.file
                            ?.name;

                        if (
                          resultFilejson.length ===
                          this
                            .queFilesUpload
                            .files
                            .length
                        ) {
                          this.childQuestion.emit(
                            this.question
                          );
                        }
                      }
                    } catch (error) {
                      x.isLoading =
                        false;

                      x.isFinished =
                        true;

                      this.checkAndEmitUploadStatus();

                      this.logError(
                        'File upload response processing failed',
                        error
                      );
                    }
                  },

                  error: (
                    error
                  ) => {
                    x.isLoading =
                      false;

                    this.checkAndEmitUploadStatus();

                    this.logError(
                      'File upload failed',
                      error
                    );
                  },
                });
            }
          }
        );
    } catch (error) {
      this.checkAndEmitUploadStatus();

      this.logError(
        'File upload setup failed',
        error
      );
    }
  }

  initializeFileResponse(): void {
    try {
      const resultFilejson:
        any[] = [];

      this.question.responseText =
        '';

      if (
        this.queFilesUpload
          .files.length > 0
      ) {
        this.queFilesUpload.files.forEach(
          (x) => {
            if (!x.file) {
              return;
            }

            resultFilejson.push(
              {
                Id: 1,
                value:
                  x.base64String,
                name:
                  x.file.name,
              }
            );

            this.question.responseText =
              JSON.stringify(
                resultFilejson
              );
          }
        );
      }

      this.childQuestion.emit(
        this.question
      );
    } catch (error) {
      this.logError(
        'File response initialization failed',
        error
      );
    }
  }

  CheckRequiredValidation(): void {
    try {
      const isRequired =
        this.question
          .isQuestionRequired ===
        'Y';

      const hasFiles =
        this.queFilesUpload
          .files.length > 0;

      this.errormgvisible =
        false;

      this.question[
        'IsValid'
      ] = true;

      if (
        isRequired &&
        !hasFiles
      ) {
        this.pushErrorMsg(
          'Input is mandatory'
        );

        this.errormgvisible =
          true;

        this.question[
          'IsValid'
        ] = false;

        this.childQuestion.emit(
          this.question
        );

        return;
      }
    } catch (error) {
      this.logError(
        'Required file validation failed',
        error
      );
    }
  }

  CheckFileValidations(): void {
    try {
      this.errormgvisible =
        false;

      let isValid = true;

      if (
        this.queFilesUpload
          .files.length > 0 &&
        this.question
          .questionFileConfig !=
          null
      ) {
        this.queFilesUpload.files.forEach(
          (file) => {
            if (
              file.filePath ===
                null ||
              file.filePath === ''
            ) {
              if (
                !this.checkFileSize(
                  file
                )
              ) {
                isValid =
                  false;
              }

              if (
                !this.checkFileExtension(
                  file
                )
              ) {
                isValid =
                  false;
              }

              if (
                !this.checkFileNameRegex(
                  file
                )
              ) {
                isValid =
                  false;
              }
            }
          }
        );

        if (
          !this.checkFileSelection(
            this.queFilesUpload
              .files
          )
        ) {
          isValid = false;
        }

        this.errormgvisible =
          this.errorMessages
            .length > 0;

        this.question[
          'IsValid'
        ] = isValid;
      } else {
        this.errormgvisible =
          false;

        this.question[
          'IsValid'
        ] = true;

        this.question[
          'responseText'
        ] = '';
      }

      this.childQuestion.emit(
        this.question
      );
    } catch (error) {
      this.question[
        'IsValid'
      ] = false;

      this.logError(
        'File validation failed',
        error
      );
    }
  }

  private checkFileSize(
    file: FileDetail
  ): boolean {
    try {
      const config =
        this.question
          .questionFileConfig;

      if (
        config.fileSizeLimitValue !=
          null &&
        config.fileSizeLimitValue >
          0 &&
        config.fileSizeLimitUnit !=
          null &&
        config.fileSizeLimitUnit
          .length > 0 &&
        file.file
      ) {
        const designedFileSize =
          config.fileSizeLimitValue +
          ' ' +
          config.fileSizeLimitUnit;

        const uploadedFileSize =
          this.bytesToSize(
            file.file.size,
            2
          );

        if (
          this.parseFileSize(
            uploadedFileSize
          ) >
          this.parseFileSize(
            designedFileSize
          )
        ) {
          this.pushErrorMsg(
            "File '" +
              file.file.name +
              "' size should be less than " +
              config.fileSizeLimitValue +
              ' ' +
              config.fileSizeLimitUnit
          );

          return false;
        }
      }

      return true;
    } catch (error) {
      this.logError(
        'File size validation failed',
        error
      );

      return false;
    }
  }

  private checkFileExtension(
    file: FileDetail
  ): boolean {
    try {
      const config =
        this.question
          .questionFileConfig;

      if (
        config.fileExtensions !=
          null &&
        config.fileExtensions
          .length > 0 &&
        file.file
      ) {
        const fileName =
          file.file.name || '';

        const lastDotIndex =
          fileName.lastIndexOf(
            '.'
          );

        const uploadedFileExtension =
          lastDotIndex >= 0
            ? fileName
                .substring(
                  lastDotIndex
                )
                .toLowerCase()
            : '';

        if (
          !config.fileExtensions.includes(
            uploadedFileExtension
          )
        ) {
          this.pushErrorMsg(
            "File '" +
              file.file.name +
              "' extension should be one of the following: " +
              config.fileExtensions.join(
                ', '
              )
          );

          return false;
        }
      }

      return true;
    } catch (error) {
      this.logError(
        'File extension validation failed',
        error
      );

      return false;
    }
  }

  private checkFileNameRegex(
    file: FileDetail
  ): boolean {
    try {
      const config =
        this.question
          .questionFileConfig;

      if (
        config.fileNameRegex !=
          null &&
        config.fileNameRegex
          .length > 0 &&
        file.file
      ) {
        const requiredPattern =
          `${config.fileNameRegex}`;

        let isMatch = false;

        try {
          isMatch =
            RE2JS.matches(
              requiredPattern,
              file.file.name
            );
        } catch (error) {
          this.logError(
            'File name pattern validation failed',
            error
          );

          this.pushErrorMsg(
            config.fileNameRegexErrorMessage ||
              'File name does not match the required pattern.'
          );

          return false;
        }

        if (!isMatch) {
          const errorMessage =
            config.fileNameRegexErrorMessage ||
            'File name does not match the required pattern.';

          this.pushErrorMsg(
            errorMessage
          );

          return false;
        }
      }

      return true;
    } catch (error) {
      this.logError(
        'File name validation failed',
        error
      );

      return false;
    }
  }

  private checkFileSelection(
    files: FileDetail[]
  ): boolean {
    try {
      const config =
        this.question
          .questionFileConfig;

      const hasMultipleFiles =
        files.length > 1;

      if (
        hasMultipleFiles &&
        config.isMultiFileSelection !==
          true
      ) {
        this.pushErrorMsg(
          'Multiple file cannot be uploaded'
        );

        return false;
      }

      return true;
    } catch (error) {
      this.logError(
        'File selection validation failed',
        error
      );

      return false;
    }
  }

  parseFileSize(
    sizeStr: string
  ): number {
    try {
      const match =
        sizeStr.match(
          /^([\d.]+)\s*(KB|MB|GB)$/i
        );

      if (!match) {
        return 0;
      }

      const value =
        match[1];

      const unit =
        match[2];

      const num =
        parseFloat(value);

      switch (
        unit.toUpperCase()
      ) {
        case 'KB':
          return (
            num * 1024
          );

        case 'MB':
          return (
            num *
            1024 *
            1024
          );

        case 'GB':
          return (
            num *
            1024 *
            1024 *
            1024
          );

        default:
          return num;
      }
    } catch (error) {
      this.logError(
        'File size parsing failed',
        error
      );

      return 0;
    }
  }

  downloadFile(
    file: FileDetail,
    fileIndex: number
  ): void {
    try {
      if (file.file != null) {
        const reader =
          new FileReader();

        reader.readAsDataURL(
          file.file
        );

        reader.onload = () => {
          try {
            if (
              reader.result
            ) {
              fs.saveAs(
                reader.result.toString(),
                file.file?.name ||
                  file.name
              );
            }
          } catch (error) {
            this.logError(
              'Local file download failed',
              error
            );
          }
        };

        reader.onerror = () => {
          this.logError(
            'Local file read failed',
            reader.error
          );
        };
      } else if (
        file.filePath != null &&
        file.filePath.length > 0
      ) {
        const payLoad = {
          filePath:
            file.filePath,
          fileName:
            file.name,
        };

        this.baseHttpService
          .post(
            this.constant
              .getPreSignedDownloadUrl,
            payLoad
          )
          .subscribe({
            next: (
              response
            ) => {
              try {
                if (
                  response &&
                  response.preSignedUrl
                ) {
                  const link =
                    document.createElement(
                      'a'
                    );

                  link.href =
                    response.preSignedUrl;

                  link.download =
                    file.name;

                  document.body.appendChild(
                    link
                  );

                  link.click();

                  document.body.removeChild(
                    link
                  );
                }
              } catch (error) {
                this.logError(
                  'File download failed',
                  error
                );
              }
            },

            error: (
              error
            ) => {
              this.logError(
                'File download URL generation failed',
                error
              );
            },
          });
      }
    } catch (error) {
      this.logError(
        'File download setup failed',
        error
      );
    }
  }

  deleteFile(
    fileIndex: number
  ): void {
    try {
      this.errormgvisible =
        false;

      this.errorMessages =
        [];

      if (
        fileIndex > -1
      ) {
        this.queFilesUpload.files.splice(
          fileIndex,
          1
        );

        this.CheckRequiredValidation();
        this.CheckFileValidations();
        this.saveFileResponse();
      }

      this.inputChange.emit(
        true
      );
    } catch (error) {
      this.logError(
        'File deletion failed',
        error
      );
    }
  }

  openBrowseWindow(
    elementId: number
  ): void {
    try {
      const fileInput =
        document.getElementById(
          'uploadfile' +
            elementId
        ) as HTMLInputElement | null;

      if (fileInput) {
        fileInput.click();
      }
    } catch (error) {
      this.logError(
        'File browser open failed',
        error
      );
    }
  }

  convertBase64ToFile(
    image: string,
    filename: string,
    typeContent: string
  ): File {
    try {
      const byteString =
        atob(image);

      const ab =
        new ArrayBuffer(
          byteString.length
        );

      const ia =
        new Uint8Array(ab);

      for (
        let i = 0;
        i < byteString.length;
        i += 1
      ) {
        ia[i] =
          byteString.charCodeAt(
            i
          );
      }

      return new File(
        [ab],
        filename,
        {
          type: typeContent,
        }
      );
    } catch (error) {
      this.logError(
        'File conversion failed',
        error
      );

      return new File(
        [],
        filename,
        {
          type: typeContent,
        }
      );
    }
  }

  ngOnInit(): void {
    try {
      this.question[
        'IsValid'
      ] = true;

      this.errorMessages =
        [];

      this.errormgvisible =
        false;

      this.queFilesUpload =
        new FileUploadQuestion();

      this.queFilesUpload.files =
        [];

      this.queFilesUpload.questionId =
        this.question.questionId;

      this.resetSubscription =
        this.cardService.resetFile$.subscribe({
          next: () => {
            try {
              this.deleteFile(
                0
              );

              this.errorMessages =
                [];
            } catch (error) {
              this.logError(
                'File reset failed',
                error
              );
            }
          },

          error: (
            error
          ) => {
            this.logError(
              'File reset subscription failed',
              error
            );
          },
        });

      if (
        this.question.responseText
      ) {
        let resp: any;

        try {
          resp =
            JSON.parse(
              this.question.responseText
            );
        } catch (error) {
          this.logError(
            'File response parsing failed',
            error
          );

          resp = null;
        }

        if (resp != null) {
          if (
            resp.ContainerName !=
              undefined &&
            resp.ContainerName
              .length > 0 &&
            resp.Files != null
          ) {
            if (
              resp.Files.length >
              0
            ) {
              const listFiles:
                any[] =
                resp['Files'];

              listFiles.forEach(
                (entry) => {
                  try {
                    const fls =
                      new FileDetail();

                    fls.name =
                      entry.Name;

                    const imageBlob =
                      this.dataURItoBlob(
                        entry.Value
                      );

                    if (
                      !imageBlob
                    ) {
                      return;
                    }

                    const imageFile =
                      new File(
                        [
                          imageBlob,
                        ],
                        entry.Name,
                        {
                          type: 'image/png',
                        }
                      );

                    fls.base64String =
                      imageBlob;

                    fls.file =
                      imageFile;

                    fls.size =
                      imageFile.size.toString();

                    this.queFilesUpload.files.push(
                      fls
                    );

                    this.question.responseText =
                      '';

                    this.initializeFileResponse();
                  } catch (
                    error
                  ) {
                    this.logError(
                      'Stored file processing failed',
                      error
                    );
                  }
                }
              );
            } else {
              this.question.responseText =
                '';
            }
          } else if (
            Array.isArray(
              resp
            ) &&
            resp.length > 0 &&
            resp[0].Id != null
          ) {
            resp.forEach(
              (entry) => {
                const fls =
                  new FileDetail();

                fls.name =
                  entry.name;

                fls.filePath =
                  entry.filePath;

                fls.id =
                  entry.Id;

                fls.sequence =
                  entry.sequence;

                fls.isFinished =
                  true;

                this.queFilesUpload.files.push(
                  fls
                );
              }
            );
          } else if (
            Array.isArray(
              resp
            ) &&
            resp.length > 0
          ) {
            resp.forEach(
              (entry) => {
                try {
                  const fls =
                    new FileDetail();

                  fls.name =
                    entry.name;

                  const imageBlob =
                    this.dataURItoBlob(
                      entry.value
                    );

                  if (
                    !imageBlob
                  ) {
                    return;
                  }

                  const imageFile =
                    new File(
                      [
                        imageBlob,
                      ],
                      entry.name,
                      {
                        type: 'image/png',
                      }
                    );

                  fls.base64String =
                    imageBlob;

                  fls.file =
                    imageFile;

                  fls.size =
                    imageFile.size.toString();

                  this.queFilesUpload.files.push(
                    fls
                  );
                } catch (
                  error
                ) {
                  this.logError(
                    'Pending file processing failed',
                    error
                  );
                }
              }
            );
          }
        }

        if (
          this.question
            .isQuestionRequired ===
          'Y'
        ) {
          this.question[
            'IsValid'
          ] = true;
        }
      }

      this.isMultiFileSelection =
        this.question
          .questionFileConfig !=
          null &&
        this.question
          .questionFileConfig
          .isMultiFileSelection !=
          null &&
        this.question
          .questionFileConfig
          .isMultiFileSelection;

      this.checkForConsentScreen();
    } catch (error) {
      this.logError(
        'File upload initialization failed',
        error
      );
    }
  }

  checkForConsentScreen(): void {
    try {
      if (
        this.question
          .isConsentQuestion &&
        this.question
          .consentQuestionLabel !=
          null &&
        this.question
          .consentQuestionLabel
          .length > 0
      ) {
        this.question.safeHtmlContent =
          this.question
            .consentQuestionLabel;
      }
    } catch (error) {
      this.logError(
        'Consent content setup failed',
        error
      );
    }
  }

  dataURItoBlob(
    dataURI: string
  ): Blob | undefined {
    try {
      if (!dataURI) {
        return undefined;
      }

      const byteString =
        atob(
          dataURI.replace(
            /^data:.*;base64,/,
            ''
          )
        );

      const arrayBuffer =
        new ArrayBuffer(
          byteString.length
        );

      const int8Array =
        new Uint8Array(
          arrayBuffer
        );

      for (
        let i = 0;
        i < byteString.length;
        i++
      ) {
        int8Array[i] =
          byteString.charCodeAt(
            i
          );
      }

      return new Blob(
        [int8Array],
        {
          type: 'image/png',
        }
      );
    } catch (error) {
      this.logError(
        'File data conversion failed',
        error
      );

      return undefined;
    }
  }

  downloadAll(): void {
    try {
      const zip =
        new JSZip();

      const downloadableFiles =
        this.queFilesUpload.files.filter(
          (x) =>
            x.file != null
        );

      const filesNum =
        downloadableFiles.length;

      if (
        filesNum === 0
      ) {
        return;
      }

      let count = 0;

      downloadableFiles.forEach(
        (x) => {
          if (!x.file) {
            return;
          }

          const reader =
            new FileReader();

          reader.readAsDataURL(
            x.file
          );

          reader.onload =
            () => {
              try {
                if (
                  !reader.result ||
                  !x.file
                ) {
                  return;
                }

                const base64String =
                  reader.result
                    .toString()
                    .replace(
                      'data:',
                      ''
                    )
                    .replace(
                      /^.+,/,
                      ''
                    );

                zip.file(
                  x.file.name,
                  base64String,
                  {
                    base64:
                      true,
                  }
                );

                count =
                  count + 1;

                if (
                  count ===
                  filesNum
                ) {
                  zip
                    .generateAsync(
                      {
                        type: 'blob',
                      }
                    )
                    .then(
                      (
                        content
                      ) => {
                        fs.saveAs(
                          content,
                          'FileUpload.zip'
                        );
                      }
                    )
                    .catch(
                      (
                        error
                      ) => {
                        this.logError(
                          'File archive generation failed',
                          error
                        );
                      }
                    );
                }
              } catch (
                error
              ) {
                this.logError(
                  'File archive processing failed',
                  error
                );
              }
            };

          reader.onerror =
            () => {
              this.logError(
                'File archive read failed',
                reader.error
              );
            };
        }
      );
    } catch (error) {
      this.logError(
        'File archive setup failed',
        error
      );
    }
  }

  pushErrorMsg(
    errorMsg: string
  ): void {
    try {
      if (
        !this.errorMessages.includes(
          errorMsg
        )
      ) {
        this.errorMessages.push(
          errorMsg
        );
      }
    } catch (error) {
      this.logError(
        'Validation message update failed',
        error
      );
    }
  }

  private checkAndEmitUploadStatus(): void {
    try {
      const anyLoading =
        this.queFilesUpload.files.some(
          (file) =>
            file.isLoading
        );

      this.fileUploadInProgress.emit(
        anyLoading
      );
    } catch (error) {
      this.logError(
        'Upload status update failed',
        error
      );
    }
  }

  private logError(
    context: string,
    error: unknown
  ): void {
    try {
      const messages: string[] =
        [];

      let currentError:
        unknown = error;

      let depth = 0;

      while (
        currentError &&
        depth < 5
      ) {
        if (
          currentError instanceof
          Error
        ) {
          messages.push(
            currentError.message ||
              currentError.name
          );

          const nestedError =
            currentError as Error & {
              cause?: unknown;
              innerException?: unknown;
              innerError?: unknown;
            };

          currentError =
            nestedError.cause ??
            nestedError.innerException ??
            nestedError.innerError ??
            null;
        } else if (
          typeof currentError ===
            'object' &&
          currentError !== null &&
          'message' in
            currentError &&
          typeof (
            currentError as {
              message?: unknown;
            }
          ).message ===
            'string'
        ) {
          messages.push(
            (
              currentError as {
                message: string;
              }
            ).message
          );

          currentError =
            null;
        } else {
          messages.push(
            'Unknown error'
          );

          currentError =
            null;
        }

        depth++;
      }

      console.error(
        `${context}${
          messages.length
            ? `: ${messages.join(
                ' | '
              )}`
            : ''
        }`
      );
    } catch {
      console.error(
        context
      );
    }
  }
}